module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.preValidation) ? _c('div', [_c('div', {
    staticClass: "centre-column"
  }, [_c('h2', [_vm._v("Reset Password")]), _vm._v(" "), (_vm.success) ? _c('div', [_c('p', [_vm._v("\n          Password successfully reset.  Please\n          "), _c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("log in")])], 1)]) : _c('div', [_c('form', {
    staticClass: "form-signin"
  }, [_c('div', {
    staticClass: "form-group",
    class: _vm.validatePassword ? '' : 'has-error'
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "inputPassword"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "inputPassword",
      "placeholder": "Password",
      "required": ""
    },
    domProps: {
      "value": _vm._s(_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: _vm.validatePassword2 ? '' : 'has-error'
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "inputPassword2"
    }
  }, [_vm._v("Re-enter Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password2),
      expression: "password2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "inputPassword2",
      "placeholder": "Re-enter password",
      "required": ""
    },
    domProps: {
      "value": _vm._s(_vm.password2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password2 = $event.target.value
      }
    }
  })]), _vm._v(" "), (!_vm.passwordsMatch) ? _c('p', {
    staticClass: "error"
  }, [_vm._v("Passwords do not match")]) : _vm._e(), _vm._v(" "), (!_vm.passwordLength) ? _c('p', {
    staticClass: "error"
  }, [_vm._v("Password must be at least " + _vm._s(_vm.passwordMinLength) + " characters")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-primary btn-block",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_vm._v("Reset")])]), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "error"
  }, [_vm._v("We apologize, but your password could not be updated at this time.  Please contact Wedge Networks support for assisstance.")]) : _vm._e()])])]) : _c('div', [_c('p', [_vm._v("We are unable to reset your password at this time.  Please contact Wedge Networks support for assistance.")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1399e3b6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PasswordReset.vue
// module id = 483
// module chunks = 2